const points = document.querySelectorAll('.scheme-point');
//const rect = document.querySelector('.scheme-rect');

if (points) {

    points.forEach(point => point.addEventListener('mouseenter', function () {
        points.forEach(e => {
            let elements = document.querySelectorAll('.scheme-item');

            elements.forEach(element => {
                element.classList.remove('active');
            });

        });

        let target = document.getElementById(this.dataset.target);

        target.classList.add('active');

        /* rect.style.top = this.dataset.offsettop + '%';
        rect.style.right = this.dataset.offsetright + '%';
        rect.style.height = ((this.dataset.id * 20) - 10) + '%'; */
    }));

}


const schemeMap = document.querySelector('.scheme-map');

if (schemeMap) {
    const schemePoints = document.querySelectorAll('.scheme-point');

    schemePoints.forEach((element, index) => {
        let offsetTop = element.dataset.offsettop;
        let offsetRight = element.dataset.offsetright;

        element.style.top = offsetTop + '%';
        element.style.right = offsetRight + '%';
    });
}